export default "__VITE_ASSET__c1dd3c20__"